import * as angular from 'angular';

const fdRulesetHtml = require('../../views/fd_ruleset.html');

'use strict';

angular.module('formApp').directive('fdRuleset', function () {
  return {
    templateUrl: fdRulesetHtml,
    replace: true
  };
});
